import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import QuoteCardOption from '../../Common/Cards/QuoteCardOption';
import CustomerSupportPhone from '../../../Account/CustomerSupportPhone';
import { SESSION_STORAGE_TERM_ALTERNATIVES_KEY, SESSION_STORAGE_AMERICO_DECLINED_REASONS_KEY, SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_HEALTH_CLASS_KEY, SESSION_STORAGE_TERM_LENGTH_KEY, getSessionStorageItem, SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY } from '../../../../sessionStorage';
import '../Americo.scss';
import '../../Quoter.scss';
import CircularProgress from "@material-ui/core/CircularProgress";
import { getTermHealthHealthClass } from '../Helpers/GetHealthClass';
import Carousel from "../../../Helpers/Widgets/SwipeCarousel/Carousel";

export default function Ineligible(props) {

  const quoteTermAlternatives = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_TERM_ALTERNATIVES_KEY));
  const reasons = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_AMERICO_DECLINED_REASONS_KEY));
  const [quoteAlternatives, setQuoteAlternatives] = useState(quoteTermAlternatives);
  const [loading, setLoading] = useState(false);
  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
  const loadingClass = loading ? 'loading' : '';
  var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  useEffect(() => {
    if (!quoteAlternatives) {
      runQuote();
    }
  }, []);

  function runQuote() {
    setLoading(true);

    const feet = props.basicInfo.height.split('ft')[0].trim();
    const inches = props.basicInfo.height.split('ft')[1].split('in')[0].trim();
    const weight = props.basicInfo.weight.split(' ')[0];

    const queryParams = {
      birthdate: props.basicInfo.birthdate,
      state: props.basicInfo.state,
      gender: props.basicInfo.gender,
      faceAmount: props.formState.coverageAmount,
      tobacco: props.basicInfo.tobacco,
      healthClass: getTermHealthHealthClass(props.formState.healthClass),
      term: (props.formState.term === "5" || props.formState.term === "7") ? "10" : props.formState.term,
      substandardRating: props.formState.healthClass === 'good' ? 'B' : '',
      heightFt: feet,
      heightIn: inches,
      weight: weight,
      oneClickAccountId: accountObj.account.oneClickAccountId,
      replacePolicy: false,
      noKnockouts: true,
    };

    fetch(`${covrServicesUrl}/api/MCT/GetMCTQuote`,
      {
        method: 'POST',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(queryParams),
      })
      .then(res => res.json())
      .then(data => {
        const quoteCardsData = data.sort((a, b) => a.monthlyRate - b.monthlyRate)
          .slice(0, 3);
        setQuoteAlternatives(quoteCardsData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }

  const getQuote = () => {
    sessionStorage.setItem(SESSION_STORAGE_TERM_LENGTH_KEY, (props.formState.term === "5" || props.formState.term === "7") ? "10" : props.formState.term);
    sessionStorage.setItem(SESSION_STORAGE_TERM_COVERAGE_AMOUNT_KEY, props.formState.coverageAmount);
    sessionStorage.setItem(SESSION_STORAGE_HEALTH_CLASS_KEY, getTermHealthHealthClass(props.formState.healthClass));
    window.location.replace(`/quote/term-life-insurance/multi-carrier-term`);
  }

  const cards = quoteAlternatives && quoteAlternatives.map((alt, index) =>
    <QuoteCardOption
      carrierName={alt.carrierName}
      productName={alt.product}
      annualRate={alt.annualRate}
      monthlyRate={alt.monthlyRate}
      logoUrl={alt.logoUrl}
      rating={alt.rating}
      productDescription={alt.productDescription}
      term={alt.termLength}
      key={index}
      id={index}
      getQuote={(carrierName) => getQuote(carrierName)}
    />)
  return (
    <div className="quoter ineligible-screen">
      <Row className="justify-content-center">
        <Col lg={6}>
          <p className="alternateCardTitle">We’re sorry - you’re not eligible for this product</p>
          <p className="alternateCardText">
            Thank you for your interest in LoanMatch Protector Life Insurance. Unfortunately, you are not eligible for this product, but don’t worry - we can help you find other suitable options.
            </p>
          {reasons && reasons.length &&
            <p className="alternateCardText">The carrier decision was based on: {reasons.join('; ')}.</p>
          }

          {!accountObj.account.isSAAS && 
            <p className="alternateCardText">
              We can help you find the right insurance coverage at the right price. Based on the information you provided in your previous application,
              we would love to show you the options you’re most likely eligible for.
                <button type="button" className="btn btn-link text-btn-link" onClick={() => { getQuote() }}>Click here</button> to see other products from our partners.
              </p>
          }
          <p className="alternateCardText">
            For an even more personalized experience, call our team of insurance experts at {CustomerSupportPhone()}.
            </p>
        </Col>
      </Row>
      {!accountObj.account.isSAAS &&
        <div className="alternatives pt-3 px-2">
          <Row className="justify-content-center mb-3">
            <Col lg={6}>
              <p className="alternateCardTitle">Loan protection buyers also considered the following</p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={8}>
              <Row className="justify-content-center">
                <Col lg={7} className={loadingClass}>
                  {(loading) ?
                    <div className="text-center">
                      <CircularProgress />
                    </div> : (cards &&
                      <div>
                        <div id="product-tile" className="d-block">
                          <div className="justify-content-center product-mobile">
                            <Carousel transform="22%" items={cards} numItems={cards.length} />
                          </div>
                          <div className="product-desktop">
                            {cards}
                          </div>
                        </div>
                      </div>
                    )
                  }
                </Col>
                <Col lg={5}>
                  <p className="alternateCardText"><b>Estimated rates based on individual plans.</b></p>
                  <p className="alternateCardText">We're sorry that the Loan protection product didn't work out. Here are some term products that could be used to protect your insurance need.</p>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      }
    </div>
  )
}

Ineligible.DefaultFormState = () => {
  return {
    coverageAmount: 300000,
    healthClass: "better",
    term: "20",
  }
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Americo/steps/Ineligible.js